import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'react-h5-audio-player/lib/styles.css';
import './tailwind.css';


import App from './App';

// Only measure the production app — localhost/dev traffic must not reach GA4.
// Uninitialized react-ga4 calls elsewhere queue silently and send nothing.
if (window.location.hostname === 'app.sayify.pro') {
  ReactGA.initialize('G-3M3F81B215');
}
const root = createRoot(document.querySelector('#root'));
root.render(
  <GoogleOAuthProvider clientId="998458869855-7s47aagf1kmuareiu2eldvgmkv3g9hat.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);
